/**
 * 顶部导航
 */
export enum EHeaderMenu {
    NewTechnology = 'NewTechnology',
    Idea = 'Idea',
    TechnologyRoadmap = 'TechnologyRoadmap',
    Workspace = 'Workspace',
    Monitor = 'Monitor',
    Empty = '',
    Project = 'Project',
    AIDisclosure = 'AIDisclosure',
    Workflow = 'Workflow',
    TechMind = 'TechMind'
}
/**
 * 路由和顶部导航的映射关系
 */
export enum ERouteMenu {
    RESULTS = EHeaderMenu.Empty,
    DISCLOSURE = EHeaderMenu.NewTechnology,
    IDEA = EHeaderMenu.Idea,
    'TECHNOLOGY-ROADMAP' = EHeaderMenu.TechnologyRoadmap,
    COMPETITOR = EHeaderMenu.Monitor,
    WORKSPACE = EHeaderMenu.Workspace,
    MONITOR = EHeaderMenu.Monitor,
    PROJECT = EHeaderMenu.Project,
    'AI-DISCLOSURE' = EHeaderMenu.AIDisclosure,
    WORKFLOW = EHeaderMenu.Workflow
}

export const HOME_PAGE = 'UNIVERSALPATENTSEARCH'
